<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between gap-3">
    <div>
      <h3 class="m-0 text-lg font-semibold">Consumables</h3>
      <p class="m-0 text-sm text-muted-color">
        Standard items and quantities added to this quote line.
      </p>
    </div>
    @if (!readOnly && !editMode) {
      <p-button
        label="Edit"
        icon="pi pi-pencil"
        severity="secondary"
        (onClick)="startEdit()"
      />
    }
  </div>

  @if (editMode) {
    <div
      class="flex flex-col gap-3 rounded border border-surface-switch-200 bg-surface-switch-50 p-3"
    >
      <p-iconfield>
        <p-inputicon styleClass="pi pi-search" />
        <input
          pInputText
          [(ngModel)]="searchQuery"
          placeholder="Search consumables"
          class="w-full"
        />
      </p-iconfield>
      @if (searchResults.length > 0) {
        <div
          class="max-h-48 overflow-y-auto rounded border border-surface-switch-200 bg-surface-switch-0"
        >
          @for (consumable of searchResults; track consumable.id) {
            <div
              class="flex items-center justify-between gap-3 border-b border-surface-switch-200 px-3 py-2 last:border-b-0"
            >
              <div class="min-w-0">
                <div class="font-medium">{{ consumable.name }}</div>
                <div class="text-sm">
                  {{ consumable.cost | currency: currencyCode }} /
                  {{ unitLabel(consumable.unit) }}
                </div>
                @if (consumable.description) {
                  <div
                    class="mt-1 text-xs italic text-muted-color line-clamp-2"
                  >
                    {{ consumable.description }}
                  </div>
                }
              </div>
              <p-button
                label="Add"
                size="small"
                severity="secondary"
                (onClick)="addConsumable(consumable)"
              />
            </div>
          }
        </div>
      } @else if (searchQuery.trim()) {
        <div
          class="rounded border border-surface-switch-200 bg-surface-switch-0 px-3 py-4 text-sm text-muted-color"
        >
          No matching consumables.
        </div>
      }

      @for (row of draft; track row.consumable.id) {
        <div class="flex items-center gap-3">
          <div class="min-w-0 flex-1">
            <div class="truncate font-medium">{{ row.consumable.name }}</div>
            @if (row.consumable.description) {
              <div class="truncate text-xs italic text-muted-color">
                {{ row.consumable.description }}
              </div>
            }
          </div>
          <div class="flex items-center gap-2">
            <p-inputNumber
              [(ngModel)]="row.quantity"
              [min]="0.000001"
              [minFractionDigits]="0"
              [maxFractionDigits]="6"
              [showButtons]="true"
              inputStyleClass="w-24"
            />
            <span class="shrink-0 text-sm text-muted-color">{{
              unitLabel(row.consumable.unit)
            }}</span>
          </div>
          <p-button
            icon="pi pi-times"
            severity="secondary"
            [text]="true"
            [rounded]="true"
            (onClick)="removeConsumable(row.consumable.id)"
          />
        </div>
      }

      <div class="flex justify-end gap-2">
        <p-button
          label="Cancel"
          severity="secondary"
          [disabled]="saving"
          (onClick)="cancelEdit()"
        />
        <p-button
          label="Save"
          icon="pi pi-check"
          [loading]="saving"
          (onClick)="save()"
        />
      </div>
    </div>
  }

  @if (item.consumable_links.length > 0) {
    <div class="flex flex-col gap-2">
      @for (link of item.consumable_links; track link.consumable.id) {
        <div
          class="flex items-center justify-between gap-3 rounded border border-surface-switch-200 bg-surface-switch-0 px-3 py-2"
        >
          <div>
            <div class="font-semibold">{{ link.consumable.name }}</div>
            <div class="text-sm">
              {{ quantityLabel(link.quantity, link.consumable.unit) }}
              &times;
              {{ link.consumable.cost | currency: currencyCode }} /
              {{ unitLabel(link.consumable.unit) }}
            </div>
            @if (link.consumable.description) {
              <div class="mt-1 text-xs italic text-muted-color line-clamp-2">
                {{ link.consumable.description }}
              </div>
            }
          </div>
          <div class="text-right font-semibold">
            {{
              extendedCost(link.consumable.cost, link.quantity)
                | currency: currencyCode
            }}
          </div>
        </div>
      }
      <div class="flex items-center justify-between px-1 text-sm">
        <span class="text-muted-color">Line consumables</span>
        <span class="text-right font-semibold">
          {{ item.subtotal_consumables | currency: currencyCode }}
          @if (
            item.quantity_mode === "scales" &&
            +(item.fixed_consumables ?? "0") !== 0
          ) {
            <span class="block text-xs font-normal text-muted-color">
              +{{ item.fixed_consumables | currency: currencyCode }} flat
            </span>
          }
        </span>
      </div>
    </div>
  } @else if (!editMode) {
    <div
      class="rounded border border-dashed border-surface-switch-300 bg-surface-switch-50 p-6 text-center text-muted-color"
    >
      No consumables added to this item.
    </div>
  }
</div>
